import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const ProductLaunchCampaign = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 151 64"
        data-fill-none
      >
        <rect
          width="151"
          height="64"
          rx="4"
          fill="#F6F1EB"
        />
        <rect
          x="85.0537"
          y="5.6875"
          width="10.75"
          height="10.75"
          rx="5.375"
          fill="white"
        />
        <rect
          x="85.0537"
          y="5.6875"
          width="10.75"
          height="10.75"
          rx="5.375"
          stroke="#1E1E1E"
          strokeWidth="0.75"
        />
        <path
          d="M93.4074 11.081C93.4074 12.577 92.318 13.8169 90.894 14.0417V11.9474H91.5881L91.7201 11.081H90.894V10.5188C90.894 10.2818 91.0094 10.0508 91.3794 10.0508H91.7551V9.31324C91.7551 9.31324 91.4141 9.2547 91.0882 9.2547C90.4078 9.2547 89.9631 9.66961 89.9631 10.4207V11.081H89.2068V11.9474H89.9631V14.0417C88.5391 13.8169 87.4497 12.577 87.4497 11.081C87.4497 9.42586 88.7834 8.08398 90.4285 8.08398C92.0736 8.08398 93.4074 9.42586 93.4074 11.081Z"
          fill="#1877F2"
        />
        <path
          d="M91.5879 11.9224L91.7199 11.0613H90.8938V10.5025C90.8938 10.267 91.0092 10.0373 91.3792 10.0373H91.7548V9.30427C91.7548 9.30427 91.414 9.24609 91.088 9.24609C90.4076 9.24609 89.9629 9.65848 89.9629 10.405V11.0613H89.2065V11.9224H89.9629V14.004C90.1146 14.0278 90.27 14.0402 90.4283 14.0402C90.5867 14.0402 90.7421 14.0278 90.8938 14.004V11.9224H91.5879Z"
          fill="white"
        />
        <rect
          x="85.0537"
          y="19.6875"
          width="10.75"
          height="10.75"
          rx="5.375"
          fill="white"
        />
        <rect
          x="85.0537"
          y="19.6875"
          width="10.75"
          height="10.75"
          rx="5.375"
          stroke="#1E1E1E"
          strokeWidth="0.75"
        />
        <g clipPath="url(#clip0_5435_134343)">
          <path
            d="M88.7492 28.0417H87.4629V23.9994H88.7492V28.0417ZM91.4196 25.1874C91.2694 25.1874 91.1254 25.2464 91.0191 25.3514C90.9129 25.4564 90.8533 25.5989 90.8533 25.7474V28.0417H89.5008V23.9994H90.8533V24.4155C91.1702 24.1501 91.5707 24.0021 91.986 23.9968C92.825 23.9968 93.4073 24.6117 93.4073 25.7788V28.0417H91.986V25.7474C91.9864 25.6736 91.972 25.6005 91.9437 25.5323C91.9154 25.464 91.8737 25.402 91.8211 25.3497C91.7684 25.2974 91.7059 25.256 91.637 25.2276C91.5681 25.1993 91.4942 25.1848 91.4196 25.1848V25.1874ZM88.773 22.7382C88.773 22.8675 88.7342 22.994 88.6615 23.1016C88.5888 23.2092 88.4855 23.293 88.3646 23.3425C88.2437 23.3921 88.1106 23.405 87.9823 23.3798C87.8539 23.3545 87.736 23.2922 87.6435 23.2007C87.551 23.1092 87.488 22.9927 87.4624 22.8658C87.4369 22.7389 87.45 22.6074 87.5001 22.4878C87.5502 22.3683 87.635 22.2661 87.7438 22.1942C87.8526 22.1224 87.9805 22.084 88.1114 22.084C88.2859 22.0854 88.4529 22.1549 88.5758 22.2774C88.6987 22.4 88.7677 22.5656 88.7677 22.7382H88.773Z"
            fill="#0A66C2"
          />
        </g>
        <rect
          x="85.0537"
          y="33.6875"
          width="10.75"
          height="10.75"
          rx="5.375"
          fill="white"
        />
        <rect
          x="85.0537"
          y="33.6875"
          width="10.75"
          height="10.75"
          rx="5.375"
          stroke="#1E1E1E"
          strokeWidth="0.75"
        />
        <g clipPath="url(#clip1_5435_134343)">
          <path
            d="M90.4287 36.1934C91.3632 36.1934 91.474 36.1969 91.8433 36.2138C92.7918 36.257 93.2348 36.707 93.278 37.6485C93.2949 38.0175 93.2981 38.1283 93.2981 39.0628C93.2981 39.9976 93.2946 40.1081 93.278 40.4771C93.2345 41.4177 92.7927 41.8686 91.8433 41.9118C91.474 41.9287 91.3638 41.9322 90.4287 41.9322C89.4942 41.9322 89.3834 41.9287 89.0144 41.9118C88.0636 41.8683 87.6229 41.4163 87.5797 40.4768C87.5628 40.1078 87.5593 39.9973 87.5593 39.0625C87.5593 38.128 87.5631 38.0175 87.5797 37.6482C87.6232 36.707 88.065 36.2567 89.0144 36.2135C89.3837 36.1969 89.4942 36.1934 90.4287 36.1934ZM90.4287 35.5625C89.4782 35.5625 89.3592 35.5666 88.9858 35.5835C87.7148 35.6418 87.0083 36.3471 86.95 37.6193C86.9328 37.993 86.9287 38.112 86.9287 39.0625C86.9287 40.013 86.9328 40.1323 86.9497 40.5057C87.008 41.7767 87.7133 42.4832 88.9855 42.5415C89.3592 42.5584 89.4782 42.5625 90.4287 42.5625C91.3793 42.5625 91.4985 42.5584 91.8719 42.5415C93.1418 42.4832 93.85 41.7779 93.9074 40.5057C93.9246 40.1323 93.9287 40.013 93.9287 39.0625C93.9287 38.112 93.9246 37.993 93.9077 37.6196C93.8505 36.3497 93.1444 35.6421 91.8722 35.5838C91.4985 35.5666 91.3793 35.5625 90.4287 35.5625V35.5625ZM90.4287 37.2652C89.4362 37.2652 88.6315 38.07 88.6315 39.0625C88.6315 40.055 89.4362 40.86 90.4287 40.86C91.4213 40.86 92.226 40.0553 92.226 39.0625C92.226 38.07 91.4213 37.2652 90.4287 37.2652ZM90.4287 40.2292C89.7844 40.2292 89.262 39.7071 89.262 39.0625C89.262 38.4182 89.7844 37.8958 90.4287 37.8958C91.073 37.8958 91.5954 38.4182 91.5954 39.0625C91.5954 39.7071 91.073 40.2292 90.4287 40.2292ZM92.2971 36.7744C92.065 36.7744 91.8768 36.9625 91.8768 37.1944C91.8768 37.4262 92.065 37.6144 92.2971 37.6144C92.529 37.6144 92.7168 37.4262 92.7168 37.1944C92.7168 36.9625 92.529 36.7744 92.2971 36.7744Z"
            fill="url(#paint0_linear_5435_134343)"
          />
        </g>
        <rect
          x="85.0537"
          y="47.6875"
          width="10.75"
          height="10.75"
          rx="5.375"
          fill="white"
        />
        <rect
          x="85.0537"
          y="47.6875"
          width="10.75"
          height="10.75"
          rx="5.375"
          stroke="#1E1E1E"
          strokeWidth="0.75"
        />
        <g clipPath="url(#clip2_5435_134343)">
          <path
            d="M93.32 50.5625H87.5374C87.376 50.5625 87.2211 50.6283 87.107 50.7456C86.9928 50.8628 86.9287 51.0217 86.9287 51.1875V54.9375C86.9287 55.1033 86.9928 55.2622 87.107 55.3794C87.2211 55.4967 87.376 55.5625 87.5374 55.5625H93.32C93.4815 55.5625 93.6363 55.4967 93.7504 55.3794C93.8646 55.2622 93.9287 55.1033 93.9287 54.9375V51.1875C93.9287 51.0217 93.8646 50.8628 93.7504 50.7456C93.6363 50.6283 93.4815 50.5625 93.32 50.5625Z"
            fill="white"
          />
          <path
            d="M93.32 50.5625H87.5374C87.376 50.5625 87.2211 50.6283 87.107 50.7456C86.9928 50.8628 86.9287 51.0217 86.9287 51.1875V54.9375C86.9287 55.1033 86.9928 55.2622 87.107 55.3794C87.2211 55.4967 87.376 55.5625 87.5374 55.5625H93.32C93.4815 55.5625 93.6363 55.4967 93.7504 55.3794C93.8646 55.2622 93.9287 55.1033 93.9287 54.9375V51.1875C93.9287 51.0217 93.8646 50.8628 93.7504 50.7456C93.6363 50.6283 93.4815 50.5625 93.32 50.5625Z"
            stroke="#1E1E1E"
            strokeWidth="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M93.6787 50.8125L90.4287 53.5625L87.1787 50.8125"
            stroke="#1E1E1E"
            strokeWidth="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          d="M65.8417 39.6536L64.0276 36.5287L64.2105 36.1689L65.6676 33.328C65.743 33.172 65.756 32.9933 65.7039 32.8277C65.6519 32.662 65.5387 32.5216 65.387 32.4346L62.2459 30.6176L62.0493 27.0254C62.0418 26.8945 61.9967 26.7683 61.9193 26.6617C61.8419 26.555 61.7354 26.4724 61.6124 26.4235C61.5292 26.3883 61.4399 26.37 61.3497 26.3697L57.7269 26.3396L55.7455 23.3155C55.6463 23.1684 55.495 23.0634 55.3217 23.0214C55.1484 22.9794 54.9659 23.0035 54.8104 23.0888L51.6643 24.8702L48.4323 23.2333C48.2749 23.1578 48.0948 23.1438 47.928 23.194C47.7612 23.2442 47.6199 23.355 47.5324 23.5042L45.71 26.6084L42.0845 26.784C41.9059 26.7922 41.7378 26.8684 41.6151 26.9966C41.4925 27.1249 41.4248 27.2954 41.4262 27.4725L41.4124 31.0659L38.9826 32.6153L38.9457 32.6375L38.3702 33.0082C38.2221 33.1034 38.1167 33.2513 38.0754 33.4215C38.0342 33.5917 38.0602 33.7714 38.1482 33.9239L38.4211 34.3956L38.8239 35.0911L38.8537 35.1393L39.9624 37.0488L38.3294 40.2499C38.247 40.4065 38.229 40.5888 38.2791 40.7589C38.3291 40.929 38.4434 41.0737 38.5981 41.163L41.7406 42.9803L41.9371 46.5725C41.9467 46.7477 42.0235 46.9129 42.1518 47.0344C42.2801 47.1559 42.4502 47.2244 42.6273 47.2259L46.2569 47.2576L47.8215 49.6437L47.8612 49.7099L48.2383 50.2818C48.3352 50.4289 48.485 50.5341 48.657 50.5758C48.8291 50.6175 49.0104 50.5926 49.1639 50.5061L50.9124 49.5166L52.31 48.7247L55.55 50.358C55.7087 50.4403 55.8931 50.4589 56.0647 50.4099C56.2362 50.3609 56.3818 50.2481 56.4709 50.095L58.2899 46.9927L61.9158 46.8158C62.0943 46.8076 62.2625 46.7315 62.3851 46.6032C62.5078 46.4749 62.5755 46.3045 62.5741 46.1274L62.5788 43.7853L62.5828 42.5313L65.6263 40.5837C65.7745 40.487 65.88 40.3381 65.9215 40.1669C65.963 39.9958 65.9374 39.8151 65.8498 39.6613L65.8417 39.6536Z"
          fill="#FFEDBF"
        />
        <path
          d="M38.8234 35.0954L38.1477 33.9265C38.0596 33.774 38.0336 33.5943 38.0748 33.424C38.1161 33.2538 38.2216 33.1059 38.3697 33.0106L41.4143 31.0628L41.4283 27.4672C41.4289 27.2918 41.4973 27.1236 41.6193 26.997C41.7414 26.8705 41.908 26.7952 42.0849 26.7867L45.7122 26.6099L47.5321 23.5057C47.6196 23.3556 47.7614 23.2442 47.929 23.1938C48.0966 23.1434 48.2775 23.1578 48.4355 23.2341L51.6752 24.8746L54.8226 23.0929C54.9761 23.0065 55.1575 22.9816 55.3296 23.0233C55.5018 23.065 55.6517 23.1702 55.7486 23.3174L57.731 26.3423L61.362 26.3742C61.5392 26.3757 61.7094 26.4442 61.8377 26.5658C61.9661 26.6873 62.043 26.8526 62.0525 27.0278L62.2494 30.6207L65.3932 32.4386C65.5483 32.5277 65.663 32.6724 65.7133 32.8427C65.7637 33.0129 65.7458 33.1955 65.6634 33.3523L64.0332 36.5406L65.8482 39.6663C65.9363 39.8188 65.9623 39.9985 65.9211 40.1688C65.8798 40.339 65.7743 40.4869 65.6262 40.5822L62.5815 42.53L62.5747 46.1259C62.5761 46.3031 62.5084 46.4736 62.3857 46.6018C62.263 46.7301 62.0948 46.8063 61.9162 46.8145L58.2888 46.9913L56.4689 50.0954C56.3795 50.2482 56.2339 50.3607 56.0623 50.4094C55.8908 50.4582 55.7065 50.4394 55.5479 50.3571L52.3065 48.7233L49.1592 50.505C49.0057 50.5914 48.8243 50.6163 48.6521 50.5746C48.48 50.5329 48.3301 50.4277 48.2332 50.2805L47.8562 49.7071"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.2773 43.584L38.1449 46.3505"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.4546 31.2539L53.5523 41.7657"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M53.18 41.2123L37.7711 45.7972L36.651 44.1372L46.8275 31.8071L53.18 41.2112L53.18 41.2123Z"
          fill="#FF5A4F"
        />
        <path
          d="M53.18 41.2123L37.7711 45.7972L36.651 44.1372L46.8275 31.8071L53.18 41.2112L53.18 41.2123Z"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.7887 43.4116C46.0006 43.651 46.1609 43.9307 46.2598 44.2333C46.3587 44.536 46.3941 44.8553 46.3637 45.1714C46.3333 45.4875 46.2379 45.7938 46.0833 46.0713C45.9287 46.3488 45.7181 46.5917 45.4647 46.785C45.2113 46.9782 44.9204 47.1177 44.6099 47.1948C44.2994 47.272 43.9759 47.2851 43.6595 47.2334C43.343 47.1818 43.0403 47.0664 42.77 46.8944C42.4997 46.7224 42.2676 46.4975 42.088 46.2336L41.1125 44.7891"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M51.5566 34.0215L54.7248 30.6092"
          stroke="black"
          strokeLinecap="round"
        />
        <path
          d="M53.0508 35.8613L55.9172 35.8331"
          stroke="black"
          strokeLinecap="round"
        />
        <path
          d="M78.9761 14.1289L76.177 16.2884"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M76.7961 13.8788L79.0016 14.1624L78.7162 16.3676"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M79.3696 27.5742L75.8343 27.5742"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M77.7967 29.1055L79.3696 27.5338L77.7967 25.962"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M79.3696 39.1152L75.8343 39.1152"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M77.7967 40.6465L79.3696 39.0748L77.7967 37.5031"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M78.9761 52.4805L76.177 50.321"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M76.7961 52.7306L79.0016 52.447L78.7162 50.2418"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_5435_134343"
            x1="91.887"
            y1="35.5625"
            x2="89.4164"
            y2="42.1335"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#5E5CCB" />
            <stop
              offset="0.18214"
              stopColor="#8D40B7"
            />
            <stop
              offset="0.431696"
              stopColor="#DA2E7C"
            />
            <stop
              offset="0.753527"
              stopColor="#F15544"
            />
            <stop
              offset="1"
              stopColor="#FECA66"
            />
          </linearGradient>
          <clipPath id="clip0_5435_134343">
            <rect
              width="5.95767"
              height="5.95767"
              fill="white"
              transform="translate(87.4497 22.084)"
            />
          </clipPath>
          <clipPath id="clip1_5435_134343">
            <rect
              width="7"
              height="7"
              fill="white"
              transform="translate(86.9287 35.5625)"
            />
          </clipPath>
          <clipPath id="clip2_5435_134343">
            <rect
              width="8"
              height="8"
              fill="white"
              transform="translate(86.4287 49.0625)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
